import {ANALYTICS, STATE, VIEW} from 'general/constants';

export const CHANGE_VIEW_ANALYTICS = {
    [VIEW.MAIN]: {
        [STATE.MAIN]: ANALYTICS.POPUP_SHOWED,
        [STATE.SMS]: ANALYTICS.POPUP_SHOWED_SMS,
        [STATE.TYP]: ANALYTICS.POPUP_SHOWED,
        [STATE.ALREADY_SUBSCRIBED]: ANALYTICS.POPUP_SHOWED,
        [STATE.PRIZE]: ANALYTICS.POPUP_SHOWED,
    },
    [VIEW.REMINDER]: {
        [STATE.MAIN]: ANALYTICS.REMINDER_SHOWED,
        [STATE.SMS]: ANALYTICS.REMINDER_SHOWED_SMS,
        [STATE.TYP]: ANALYTICS.REMINDER_SHOWED,
        [STATE.ALREADY_SUBSCRIBED]: ANALYTICS.REMINDER_SHOWED,
        [STATE.PRIZE]: ANALYTICS.REMINDER_SHOWED,
    },
} as const;
